require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-ndaa-amendment-ends-u-s-support-to-military-controlled.json") })
        }
      }, "path---en-us-update-ndaa-amendment-ends-u-s-support-to-military-controlled");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-ndaa-amendment-ends-u-s-support-to-military-controlled!./.cache/json/en-us-update-ndaa-amendment-ends-u-s-support-to-military-controlled.json
// module id = 778
// module chunks = 231608221292675